import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component'
import { LogoutComponent } from './logout/logout.component'
import { SignupComponent } from './signup/signup.component'
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component'
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component'
import { SetNewPasswordComponent } from './set-new-password/set-new-password.component'
import { ResetVaPasswordComponent } from './reset-va-password/reset-va-password.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'signup', component: SignupComponent },
  { path: 'confirm-email', component: ConfirmEmailComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'set-new-password/:id', component: SetNewPasswordComponent },
  { path: 'signup/:agent_id/va/:id', component: ResetVaPasswordComponent },
  { path: 'signup/:agent_id/dashboard/:id', component: ResetVaPasswordComponent, data: {region: 'dashboard'} },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
